var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhool(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 33,
    viewBox: "0 0 35 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.4005 15.7772C32.996 16.0431 34.1261 16.9548 34.563 18.142L33.1764 14.3526C32.7396 13.1655 31.6189 12.2538 30.0139 11.9879L23.328 10.8577L24.7145 14.6471L31.4005 15.7772Z",
    fill: "url(#paint0_linear_2276_10896)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.71268 15.2549C2.70987 12.9472 5.68243 11.4466 8.3511 11.893L15.0465 13.0231L13.6599 9.23381L6.96451 8.10367C4.29584 7.65731 1.32328 9.15784 0.326087 11.4656C-0.0727894 12.3868 -0.0917975 13.2986 0.193114 14.0963L1.5797 17.8856C1.29479 17.0974 1.3138 16.1857 1.71268 15.2549Z",
    fill: "url(#paint1_linear_2276_10896)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.8164 29.7854L7.42981 25.9961C7.1449 25.2078 7.1639 24.2961 7.56278 23.3654L10.0605 17.5817L11.4471 21.371L8.94937 27.1547C8.55049 28.0759 8.53149 28.9876 8.8164 29.7854Z",
    fill: "url(#paint2_linear_2276_10896)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M24.1828 3.8775C25.3794 4.07694 26.3196 4.64676 26.8895 5.40653C27.0794 5.66295 27.2313 5.93837 27.3453 6.23278L25.9587 2.44345C25.5219 1.25632 24.4012 0.344601 22.7962 0.0786829C20.1275 -0.367678 17.155 1.13286 16.1578 3.44065L13.66 9.22434L15.0466 13.0137L17.5444 7.22996C18.5415 4.92218 21.5141 3.42165 24.1828 3.86801V3.8775Z",
    fill: "url(#paint3_linear_2276_10896)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M1.51329 15.141C1.03844 16.2331 1.06694 17.3633 1.57978 18.313C2.1496 19.3482 3.26073 20.0794 4.6378 20.3168L11.1718 21.4185L8.74053 27.0503C8.26568 28.1424 8.29418 29.2726 8.80702 30.2223C9.36734 31.2575 10.488 31.9887 11.8651 32.2262C14.5813 32.682 17.6298 31.1435 18.6459 28.7882L21.1057 23.0995L27.6967 24.2106C30.4223 24.6665 33.4614 23.128 34.4776 20.7727C34.9524 19.6806 34.9239 18.5504 34.4111 17.6007C33.8508 16.5655 32.7301 15.8343 31.353 15.5968L24.8285 14.4952L27.2598 8.86341C27.7346 7.77125 27.7061 6.6411 27.1933 5.6914C26.633 4.65622 25.5123 3.92495 24.1353 3.68752C21.4191 3.23166 18.3705 4.77018 17.3544 7.12545L14.9041 12.8142L8.31315 11.703C6.07185 11.3231 3.60266 12.3108 2.24458 13.9823C1.95967 14.3337 1.71275 14.7231 1.5323 15.141H1.51329ZM17.5823 7.22991C18.551 4.97911 21.4666 3.50708 24.0783 3.94394C25.3794 4.16238 26.424 4.84616 26.9559 5.81486C27.4307 6.69809 27.4592 7.74276 27.0128 8.75894L24.4487 14.6946L31.3055 15.8532C32.6066 16.0717 33.6513 16.7555 34.1832 17.7242C34.658 18.6074 34.6865 19.6521 34.2401 20.6682C33.2714 22.919 30.3558 24.3911 27.7441 23.9542L20.9538 22.8146L18.418 28.6932C17.4493 30.944 14.5338 32.4161 11.9221 31.9792C10.621 31.7608 9.57628 31.077 9.04444 30.1083C8.56959 29.2251 8.5411 28.1804 8.98746 27.1642L11.5517 21.2286L4.69478 20.0699C3.39368 19.8515 2.34904 19.1677 1.8172 18.199C1.34235 17.3158 1.31386 16.2711 1.76022 15.2549C2.72892 13.0041 5.64448 11.5321 8.25617 11.9689L15.0466 13.1181L17.5823 7.24891V7.22991Z",
    fill: "#00E7CB"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M34.4395 20.7727C33.4423 23.0805 30.4698 24.581 27.8011 24.1347L21.1152 23.0045L18.6175 28.7882C17.6203 31.096 14.6477 32.5966 11.979 32.1502C9.31036 31.7038 7.95228 29.4625 8.94947 27.1548L11.4472 21.371L4.75174 20.2409C2.08307 19.7945 0.725045 17.5532 1.72223 15.2455C2.71942 12.9377 5.69199 11.4371 8.36066 11.8835L15.0561 13.0137L17.5538 7.22994C18.551 4.92216 21.5236 3.42163 24.1922 3.86799C26.8609 4.31435 28.219 6.55565 27.2218 8.86344L24.7241 14.6471L31.41 15.7773C34.0786 16.2236 35.4367 18.465 34.4395 20.7727Z",
    fill: "#00E7CB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2276_10896",
    x1: 28.9455,
    y1: 18.142,
    x2: 28.9455,
    y2: 10.8577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E7CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008171"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2276_10896",
    x1: 7.52326,
    y1: 17.8856,
    x2: 7.52326,
    y2: 8.02511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E7CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008171"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2276_10896",
    x1: 9.3419,
    y1: 29.7854,
    x2: 9.3419,
    y2: 17.5817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E7CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008171"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2276_10896",
    x1: 20.5027,
    y1: 13.0137,
    x2: 20.5027,
    y2: 0.00012207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E7CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008171"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhool);
export default __webpack_public_path__ + "static/media/phool.322f9ca7f40cab08a8727170b17b7501.svg";
export { ForwardRef as ReactComponent };